import { createSurveyStyles } from '@sm/webassets';
import { ThemeShape } from '~app/sharedTypes';

const useSurveyStyles = createSurveyStyles((theme: ThemeShape) => {
  return {
    exitLink: {
      padding: 0,
      height: 'auto',
      fontFamily: 'inherit',
      fontSize: theme?.exitLink?.fontSize,
      fontWeight: theme?.exitLink?.fontWeight,
      color: theme?.primaryAccentColor,
      backgroundColor: theme?.exitLink?.backgroundColor,
      '&:hover': {
        textDecoration: 'none',
      },
    },
  };
});

export default useSurveyStyles;
